import moment from 'moment'

import {
  SCHEDULE_ENTRIES
} from '../../config/constants'

import setScheduleEntry from './schedule_entry'

const saveSessionToSchedule = (user, otherUser, sessionLength, startTime, sessionId) => {
  const endTime = moment(startTime).add(sessionLength, 'minutes').valueOf()
  const uid = user.get('uid')

  const payload = {
    user: {
      name: user.get('name'),
      uid: user.get('uid'),
      profileImage: user.get('profileImage'),
      profileUrl: user.get('profileUrl')
    },
    otherUser: {
      name: otherUser.get('name'),
      uid: otherUser.get('uid'),
      profileImage: otherUser.get('profileImage'),
      profileUrl: otherUser.get('profileUrl')
    }
  }

  return setScheduleEntry(uid, startTime, endTime, SCHEDULE_ENTRIES.BOOKED, sessionId, payload)
}


export default (expert, user, sessionLength, startTime, sessionId) => {
  return saveSessionToSchedule(expert, user, sessionLength, startTime, sessionId)
    .then(saveSessionToSchedule.bind(null, user, expert, sessionLength, startTime, sessionId))
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/setters/save_session_to_schedules.js
 **/